import React, { useState } from "react";
import graph from "./graph";
import Agreement from "./Agreement";
import Lottie from "react-lottie";
import jMoment from "moment-jalaali";
import animationData from "assets/json/check.json";
import NavigateNextRounded from "@mui/icons-material/NavigateNextRounded";

import {
  Box,
  Grow,
  Stack,
  Button,
  IconButton,
  Typography,
  CircularProgress,
} from "@mui/material";

import { toast } from "react-toastify";
import { CustomList } from "components";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { isEmptyObject } from "helpers/formatObject";

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
const Form = ({ state, refetch, handleNext, handleBack, handleState }) => {
  const {
    id,
    title,
    address,
    tellphone,
    postal_code,
    register_date,
    registered_number,
    national_identifier,
  } = state;

  const [agreement, setAgreement] = useState(false);

  const { userToken } = useSelector((state) => state.auth);

  const [request, { loading }] = useMutation(graph.request.query, {
    context: {
      serviceName: graph.request.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onRequest = async () => {
    try {
      const { data, errors } = await request({
        variables: { lab_id: id },
      });
      if (!errors) {
        refetch();
        if (!isEmptyObject(data)) {
          toast.success("اطلاعات شما در صف بررسی قرار گرفت.");
          //   data[graph.request.name]?.messages.map((message) =>
          //     toast.success(String(message))
          //   );
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <Stack p={1} flexGrow={1} rowGap={2} overflow="scroll">
        <Grow in>
          <Stack py={2} rowGap={2}>
            <Lottie options={defaultOptions} height={200} width={200} />
            <Typography align="center" variant="subtitle2" color="textDisabled">
              آیا مشخصات را تایید میکنید؟
            </Typography>
            <Typography align="center" variant="caption" color="textDisabled">
              پس از تایید، مدارک شما در صف بررسی قرار خواهد گرفت
            </Typography>
          </Stack>
        </Grow>
        <Box>
          <CustomList
            data={{
              title,
              children: [
                {
                  title: "شناسه ملی",
                  value: national_identifier,
                },
                {
                  title: "شماره ثبت",
                  value: registered_number,
                },
                {
                  title: "تاریخ ثبت",
                  value: jMoment(register_date).format("jYYYY/jMM/jDD") || "-",
                },
                {
                  title: "تلفن",
                  value: tellphone,
                },
                {
                  title: "کدپستی",
                  value: postal_code,
                },
                {
                  title: "آدرس",
                  value: address,
                },
              ],
            }}
          />
          <Agreement agreement={agreement} setAgreement={setAgreement} />
        </Box>
      </Stack>

      <Stack
        p={1}
        py={2}
        columnGap={1}
        alignItems="center"
        direction="row-reverse"
      >
        {/* <Button>گزارش عدم تطابق</Button> */}
        {/* <Button>قوانین و مقررات</Button> */}
        <Button
          autoFocus
          fullWidth
          size="large"
          color="success"
          variant="contained"
          disabled={loading}
          onClick={onRequest}
        >
          {loading ? (
            <CircularProgress color="inherit" size={24} />
          ) : (
            "تایید نهایی"
          )}
        </Button>
        <IconButton size="medium" color="warning" onClick={handleBack}>
          <NavigateNextRounded />
        </IconButton>
      </Stack>
    </>
  );
};

export default Form;
